export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20illustration%20of%20a%20bustling%20Chinese%20online%20community%20hub%2C%20diverse%20group%20of%20people%20engaged%20in%20discussion%2C%20soft%20coral%20and%20warm%20beige%20color%20palette%2C%20modern%20editorial%20style%2C%20friendly%20atmosphere%2C%20abstract%20geometric%20shapes%2C%20gentle%20gradient%20background&width=1040&height=780&seq=about-community-01&orientation=landscape"
                alt="吃瓜网51社区介绍 - 网友交流讨论的平台氛围"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 w-full flex flex-col gap-4">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium w-fit">
              <i className="ri-information-line text-sm"></i>
              平台介绍
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">关于吃瓜网51</h2>
            <div className="space-y-3">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                吃瓜网51成立于2020年，是国内领先的娱乐八卦与生活话题互动社区。我们致力于为广大网友提供一个自由、开放、有趣的信息交流平台，让每个人都能在这里找到感兴趣的话题并参与讨论。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                平台涵盖明星八卦、影视综艺、社会热点、情感生活、搞笑趣闻等多个话题圈，日均活跃用户超过50万。无论是追踪最新娱乐动态，还是分享身边的奇闻趣事，吃瓜网51都是你最值得信赖的吃瓜大本营。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                我们坚持真实、客观、有趣的社区氛围，鼓励用户理性讨论、文明发言，共同维护良好的交流环境。
              </p>
            </div>
            <div className="grid grid-cols-3 gap-4 mt-2">
              <div className="flex flex-col items-center p-4 rounded-xl bg-background-50">
                <span className="font-heading font-bold text-xl md:text-2xl text-primary-500">2020年</span>
                <span className="text-xs text-foreground-500">平台成立</span>
              </div>
              <div className="flex flex-col items-center p-4 rounded-xl bg-background-50">
                <span className="font-heading font-bold text-xl md:text-2xl text-accent-500">300+</span>
                <span className="text-xs text-foreground-500">话题圈子</span>
              </div>
              <div className="flex flex-col items-center p-4 rounded-xl bg-background-50">
                <span className="font-heading font-bold text-xl md:text-2xl text-secondary-500">99.9%</span>
                <span className="text-xs text-foreground-500">服务可用率</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}